module.exports = __webpack_public_path__ + "img/ct-facebook.0c1d159b.png";